namespace TabAurous.OMS {
    export namespace DesignBOMService {
        export const baseUrl = 'OMS/DesignBOM';

        export declare function Create(request: Serenity.SaveRequest<DesignBOMRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<DesignBOMRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<DesignBOMRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function GetDesignBOM(request: ProductRequest, onSuccess?: (response: Serenity.ListResponse<DesignBOMRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<DesignBOMRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "OMS/DesignBOM/Create",
            Update = "OMS/DesignBOM/Update",
            Delete = "OMS/DesignBOM/Delete",
            Retrieve = "OMS/DesignBOM/Retrieve",
            GetDesignBOM = "OMS/DesignBOM/GetDesignBOM",
            List = "OMS/DesignBOM/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'GetDesignBOM', 
            'List'
        ].forEach(x => {
            (<any>DesignBOMService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
